exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vue-treeselect__portal-target .vue-treeselect__menu-container {\r\n  min-width: 280px;\n}\n.vue-treeselect__portal-target .vue-treeselect__menu {\r\n  font-size: 14px;\r\n  padding: 6px 0;\n}\n.vue-treeselect__portal-target .vue-treeselect__option {\r\n  padding: 7px 12px;\r\n  font-size: 14px;\r\n  line-height: 1.5;\n}\n.vue-treeselect__portal-target .vue-treeselect__label {\r\n  font-size: 14px;\n}\n.vue-treeselect__portal-target .vue-treeselect__option--selected .vue-treeselect__label,\r\n.vue-treeselect__portal-target .vue-treeselect__option--highlight .vue-treeselect__label {\r\n  font-weight: 600;\n}\r\n", ""]);

// exports
